import { Button } from "react-migration/components/DeprecatedButton";
import { FinalStepWrapper } from "./FinalStepWrapper";
import classNames from "classnames";
import { letterStore } from "src/js/stores/letter/store";
import { useSnapshot } from "valtio";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";

type LetterSuccessProps = {
  onViewLettersClick: () => void;
  onGoToSitesClick: () => void;
};

export const LetterSuccess = ({ onViewLettersClick, onGoToSitesClick }: LetterSuccessProps) => {
  const { t } = useTranslation();
  const { selectedStageIds, selectedSiteIds } = useSnapshot(letterStore);

  return (
    <FinalStepWrapper>
      <div className={classNames("flex", "w-20", "h-20", "justify-center", "items-center", "rounded-full")}>
        <i className={classNames("icon-lt-clock-line", "text-6xl", "flex", "text-text-base-primary")} />
      </div>

      <span className={classNames("my-4", "text-content", "font-semibold", "text-xl", "leading-7")}>
        {t("sites.letters.your_letters_are_being_created")}
      </span>

      <span
        className={classNames(
          "font-normal",
          "text-base",
          "leading-6",
          "text-center",
          "whitespace-pre-line",
          "text-text-base-secondary",
          "mb-4"
        )}
      >
        {t("sites.letters.our_system_is_creating_pdfs")}
      </span>

      <span
        className={classNames(
          "font-normal",
          "text-base",
          "leading-6",
          "text-center",
          "whitespace-pre-line",
          "text-text-base-secondary"
        )}
      >
        {t("sites.letters.to_check_the_status_of_your_batch")}
      </span>

      <Button.Primary data-testid="view-letters-button" className="my-4" onClick={onViewLettersClick}>
        {selectedStageIds?.length === 1 && !selectedSiteIds?.length
          ? t("sites.letters.view_letter_campaigns")
          : t("sites.letters.view_letters")}
      </Button.Primary>

      <Button.Secondary data-testid="go-to-sites-button" onClick={onGoToSitesClick}>
        {t("sites.letters.go_to_saved_sites")}
      </Button.Secondary>
    </FinalStepWrapper>
  );
};
